import { createSlice } from "@reduxjs/toolkit";
import { 
  getResultadosEvaluacionThunk, 
  getEstadisticasCompletasThunk 
} from "./resultadosEvaluacion.thunks";

const initialState = {
  resultados: [],
  count: 0,
  next: null,
  previous: null,
  currentPage: 1,
  loading: false,
  error: null,
  
  estadisticas: {
    completada: 0,
    en_progreso: 0,
    sin_sesion: 0,
    total: 0,
  },
  estadisticasLoading: false,
  estadisticasError: null,
};

const resultadosEvaluacionSlice = createSlice({
  name: "resultadosEvaluacion",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
      state.estadisticasError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ================================
      // GET RESULTADOS EVALUACION
      // ================================
      .addCase(getResultadosEvaluacionThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getResultadosEvaluacionThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.resultados = action.payload.results;
        state.count = action.payload.count;
        state.next = action.payload.next;
        state.previous = action.payload.previous;
      })
      .addCase(getResultadosEvaluacionThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // ================================
      // GET ESTADISTICAS COMPLETAS
      // ================================
      .addCase(getEstadisticasCompletasThunk.pending, (state) => {
        state.estadisticasLoading = true;
        state.estadisticasError = null;
      })
      .addCase(getEstadisticasCompletasThunk.fulfilled, (state, action) => {
        state.estadisticasLoading = false;
        state.estadisticas = action.payload;
      })
      .addCase(getEstadisticasCompletasThunk.rejected, (state, action) => {
        state.estadisticasLoading = false;
        state.estadisticasError = action.payload;
      });
  },
});

export const { clearError } = resultadosEvaluacionSlice.actions;
export default resultadosEvaluacionSlice.reducer;
